import { html, nothing } from 'lit';
import type { TefComsLoader } from '@src/components/TefComsLoader';

// Loading indicator
export const tefComsLoader = function render(this: TefComsLoader) : ReturnType<typeof html> {
  return html`
     <div class="loader" cloak=${this.cloak || nothing}>
      <div class="dot dot-1"></div>
      <div class="dot dot-2"></div>
    </div>`;
};
